import { createApp } from 'vue';
import moment from "moment";
import { createVfm } from 'vue-final-modal';
import 'vue-final-modal/style.css';
import axios from "axios";
import vueScrollto from 'vue-scrollto';
import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
import { required, min, max, email, confirmed } from '@vee-validate/rules';
import * as yup from "yup";
import router from './router';
import vSelect from 'vue-select';
import Notifications from '@kyvg/vue3-notification';
import { createStore } from 'vuex';
import { InstallCodemirro } from "codemirror-editor-vue3"
import VueTailwindDatepicker from 'vue-tailwind-datepicker'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

// Create a new store instance.
const store = createStore({
    state () {
        return {
            user: {},
            account: {},
            userIsAccountLevelAdmin: false,
            userIsAuditor: false,
            userIsQuestionAdmin:false,
            onlyPilotNetwork: false,
        }
    },
    mutations: {
        addUserIsAccountLevelAdmin (state, userIsAccountLevelAdmin) {
            state.userIsAccountLevelAdmin = userIsAccountLevelAdmin;
        },
        addUserIsAuditor (state, userIsAuditor) {
            state.userIsAuditor = userIsAuditor;
        },
        addUserIsQuestionAdmin (state, userIsQuestionAdmin) {
            state.userIsQuestionAdmin = userIsQuestionAdmin;
        },
        addOnlyPilotNetwork (state, onlyPilotNetwork) {
            state.onlyPilotNetwork = onlyPilotNetwork;
        },
        addUser (state, user) {
            state.user = user;
        },
        addAccount (state, account) {
            state.account = account;
        },
    }
})

defineRule('required', required);
defineRule('min', min);
defineRule('max', max);
defineRule('email', email);
defineRule('confirmed', confirmed);

window.moment = moment;
window.axios = axios;
window.yup = yup;

const app = createApp({});
const vfm = createVfm();

app.use(vfm);
app.use(vueScrollto);
app.use(router);
app.use(Notifications);
app.use(store);
app.use(InstallCodemirro);
app.use(VueTailwindDatepicker);

app.component('VueDatePicker', VueDatePicker);

app.component('Field', Field);
app.component('Form', Form);
app.component('ErrorMessage', ErrorMessage);
app.component('v-select', vSelect);

const files = require.context('./', true, /\.vue$/i);
files.keys().forEach(key => {
    const componentConfig = files(key);
    const componentName = key.split('/').pop().split('.')[0];
    app.component(componentName, componentConfig.default || componentConfig);
});
// app.component('draggable', draggable)
app.component('action-tracker', require('./components/ActionTrackerComponent.vue').default);
app.component('action-tracker-filter', require('./components/ActionTrackerFilterComponent.vue').default);
app.component('action-tracker-action', require('./components/ActionTrackerActionComponent.vue').default);
app.component('action-tracker-ai', require('./components/ActionTrackerAIComponent.vue').default);
app.component('document', require('./components/DocumentComponent.vue').default);
app.component('document-view-component', require('./components/DocumentViewComponent.vue').default);
app.component('payment-form', require('./components/PaymentForm.vue').default);
app.component('coupon', require('./components/Coupon.vue').default);
app.component('register', require('./components/Register.vue').default);
app.component('register-in-network', require('./components/RegisterInNetwork.vue').default);
app.component('upgrade', require('./components/Upgrade.vue').default);
app.component('payment-info', require('./components/PaymentInfo.vue').default);
app.component('payment-update', require('./components/PaymentUpdate.vue').default);
app.component('addon-product', require('./components/AddonProduct.vue').default);
app.component('question-checkpoint', require('./components/QuestionCheckpoint.vue').default);
app.component('consumer-duty', require('./components/ConsumerDutyComponent.vue').default);
app.component('consumer-duty-current-report', require('./components/ConsumerDutyCurrentReportComponent.vue').default);
app.component('vulnerability-evidence-component', require('./components/VulnerabilityEvidenceComponent.vue').default);
app.component('intelliflo-office-connection-info', require('./components/IntellifloOfficeConnectionInfo.vue').default);
app.component('intelliflo-office-missing-data-table', require('./components/IntellifloOfficeMissingDataTable.vue').default);
app.component('intelliflo-office-duplicate-clients-table', require('./components/IntellifloOfficeDuplicateClientsTable.vue').default);
app.component('intelliflo-office-documents-table', require('./components/IntellifloOfficeDocumentsTable.vue').default);
app.component('intelliflo-office-plans-table', require('./components/IntellifloOfficePlansTable.vue').default);
app.component('intelliflo-office-client-file-reviews', require('./components/IntellifloOfficeClientFileReviewsComponent.vue').default);
app.component('intelliflo-office-documents-report', require('./components/IntellifloOfficeDocumentsReportComponent.vue').default);
app.component('intelliflo-office-plans-report', require('./components/IntellifloOfficePlansReportComponent.vue').default);
app.component('intelliflo-office-client-form', require('./components/IntellifloOfficeClientForm.vue').default);
app.component('pagination', require('./components/PaginationComponent.vue').default);
app.component('network-account-config', require('./components/NetworkAccountConfigComponent.vue').default);
app.component('additional-form-component', require('./components/AdditionalFormComponent.vue').default);
app.component('fca-firm-info-component', require('./components/FCAFirmInfoComponent.vue').default);
app.component('fca-form-individual-permission-component', require('./components/FCAFormIndividualPermissionComponent.vue').default);
app.component('fca-firm-show-data-component', require('./components/FCAFirmShowDataComponent.vue').default);
app.component('companies-house-info-component', require('./components/CompaniesHouseInfoComponent.vue').default);
app.component('main-view', require('./views/Main/MainView.vue').default);
app.component('track-performance-component', require('./components/TrackPerformanceComponent.vue').default);

app.mount('#app');
